import { PmsColor } from '@midocean/webapps-shared-domain';
import { AnnotationShape } from '../../typings/common';
import { NotificationResult } from '../../typings/notification';

export const maxNumberOfColoursValidator = (
  shapes: AnnotationShape[],
  maximumColors: number,
  printPositionName: string,
  checkColors: boolean
): NotificationResult => {
  const validatorName = 'maxNumberOfColoursValidator';

  if (checkColors) {
    const coloursToValidate = [];

    for (const shape of shapes) {
      if (shape.kind === 'Logo' && shape.pmsColorsInPngFile) {
        const { pmsColorsInPngFile } = shape;
        coloursToValidate.push(...pmsColorsInPngFile);
      } else if (shape.kind === 'Text') {
        coloursToValidate.push({
          name: shape.w2pText.colorName,
          red: shape.w2pText.color[0],
          green: shape.w2pText.color[1],
          blue: shape.w2pText.color[2],
        } as PmsColor);
      }
    }

    const coloursWithoutDuplicates = [
      ...new Set(coloursToValidate.map((item) => item.name)),
    ];

    if (coloursWithoutDuplicates.length > maximumColors) {
      return {
        printPositionName,
        validatorName,
        validatorColor: 'Red',
        message: '',
      };
    }
  }

  return {
    printPositionName,
    validatorName,
    validatorColor: 'Green',
    message: '',
  };
};
